import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var Two = styled.div.withConfig({
  displayName: "partials__Two",
  componentId: "sc-164d4f5-0"
})(["display:grid;grid-template-columns:1fr 1fr;gap:12px;", ""], maxMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: block;\n  "]))));
export var Three = styled.div.withConfig({
  displayName: "partials__Three",
  componentId: "sc-164d4f5-1"
})(["display:grid;grid-template-columns:1fr 1fr 1fr;gap:", ";", ""], function (_ref) {
  var _ref$gap = _ref.gap,
    gap = _ref$gap === void 0 ? '12px' : _ref$gap;
  return gap;
}, maxMediaQueries.phablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: block;\n  "]))));
export var MainColumn = styled.div.withConfig({
  displayName: "partials__MainColumn",
  componentId: "sc-164d4f5-2"
})(["margin-bottom:12px;", ""], maxMediaQueries.phablet(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin-bottom: 48px;\n  "]))));
export var ProductsBlock = styled.div.withConfig({
  displayName: "partials__ProductsBlock",
  componentId: "sc-164d4f5-3"
})(["width:100%;height:auto;padding:18px 16px;border-radius:", ";box-shadow:", ";background-color:", ";hr{border-top:1px solid ", ";margin:36px auto;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.boxShadow;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.uiL;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.ui;
});
export var MainContents = styled.div.withConfig({
  displayName: "partials__MainContents",
  componentId: "sc-164d4f5-4"
})(["margin-bottom:12px;"]);
export var WithRightContent = styled(MainContents).withConfig({
  displayName: "partials__WithRightContent",
  componentId: "sc-164d4f5-5"
})(["display:grid;grid-template-columns:8fr 4fr;gap:", ";", ";"], function (_ref6) {
  var _ref6$gap = _ref6.gap,
    gap = _ref6$gap === void 0 ? '12px' : _ref6$gap;
  return gap;
}, maxMediaQueries.phablet(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    display: block;\n  "]))));